<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h3>Raporty z monitoringów oferenta</h3>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-layout align-center justify-center row>
			<v-flex xs1/>
			<v-flex xs4>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="searchedFields.projectCode"
					label="Nr projektu"
					aria-label="project code"
					for="bidder-monitoring-list-project-code"
					id="bidder-monitoring-list-project-code"
				></v-text-field>
			</v-flex>
			<v-spacer/>
			<v-spacer/>
			<v-flex xs4>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-data-table
			:headers="headers"
			:rows-per-page-items="[10,20,25]"
			:items="monitoringReports"
			:pagination.sync="pagination"
			:total-items="itemCount"
			class="elevation-1">
			<template v-slot:items="props">
				<tr :class="{ 'primary--text': props.item.mutualProject }">
					<td>{{ props.item.projectCode }}</td>
					<td>{{ props.item.projectName }}</td>
					<td>{{ props.item.contestName }}</td>
					<td>{{ props.item.finishDate }}</td>
					<td>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon @click="goToReportPanel(props.item)">
									<v-icon v-on="on">
										description
									</v-icon>
								</v-btn>
							</template>
							<span>Podgląd</span>
						</v-tooltip>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {Pagination} from "@/utils/PaginationUtils";
	import {ExportUtils} from "@/utils/ExportUtils";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "BidderMonitoringList",

    mixins: [Filters],

		data () {
			return {
				headers: [
					{text: "Nr projektu", value: "projectCode", align: "left", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Nazwa konkursu", value: "contestName", sortable: true},
					{text: "Data wysłania", value: "finishDate", sortable: true},
					{text: "Akcje", value: "action", sortable: false}
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
				},
				search: "",
				searchedFields: Pagination.initSearchedFields([
					'bidderId',
					'projectCode',
				]),
				monitoringReports: []
			};
		},

		created () {
      this.searchedFields = this.retrieveFilters(this.searchedFields);
      this.pagination = this.retrievePagination(this.pagination);
		},

		watch: {
			"pagination": {
				handler (pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},
		},

		methods: {
			buildNewSearch () {
				this.search = this.buildSearchCriteria();
				this.getItemList();
			},

			buildSearchCriteria () {
				this.searchedFields.bidderId = this.$route.params.bidderId;
				return Pagination.buildSearchCriteria(this.searchedFields, true);
			},

			buildSort () {
				let order = this.pagination.descending ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			exportData () {
				let search = this.search;
				let sort = this.buildSort();
				let endpointMainPath = "monitoring-report";
				let path = "/" + endpointMainPath + "/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList () {
				if (this.search === "") {
					this.search = this.buildSearchCriteria();
				}
				let sort = this.buildSort();
				Api.get(this,
					"/monitoring-report/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.monitoringReports = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			resetSearch () {
				Pagination.resetSearch(this.searchedFields);
				this.search = "";
				this.getItemList();
			},
			goToReportPanel (item) {
				this.$router.push("/app/" + item.contestId + "/" + item.projectId + "/monitoring-form/" + item.id);
			},
		},
	};
</script>

<style scoped>

</style>
